import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", {
      filter: "createdOn",
      filterType: "date",
      sort: "createdOn",
      width: "140"
    }, "Data invio"),
    /*#__PURE__*/_createElementVNode("td", {
      filter: "mailTemplateName",
      sort: "mailTemplateName",
      width: "170"
    }, "Template name"),
    /*#__PURE__*/_createElementVNode("td", {
      filter: "mailTemplateNumber",
      sort: "mailTemplateNumber"
    }, "Template number"),
    /*#__PURE__*/_createElementVNode("td", {
      filter: "recipients",
      sort: "recipients",
      width: "160"
    }, "Destinatari"),
    /*#__PURE__*/_createElementVNode("td", {
      filter: "jsonVariables",
      sort: "jsonVariables",
      width: "220"
    }, "Variabili"),
    /*#__PURE__*/_createElementVNode("td")
  ])
], -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { colspan: "99" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_op_table, {
      class: "table table-striped",
      itemsPerPage: _ctx.filter.perPage,
      items: _ctx.tableResult.data,
      filter: _ctx.filter,
      totalItemsCount: _ctx.tableResult.count,
      onSearch: _ctx.search
    }, {
      default: _withCtx((opData) => [
        _hoisted_1,
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
                _createElementVNode("td", _hoisted_3, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.items as OM.MailSentLog[]), (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.createdOn, "YYYY-MM-DD HH:mm")), 1),
              _createElementVNode("td", null, _toDisplayString(item.mailTemplateName), 1),
              _createElementVNode("td", null, _toDisplayString(item.mailTemplateNumber), 1),
              _createElementVNode("td", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.recipients, (it, i) => {
                  return (_openBlock(), _createElementBlock("span", { key: i }, [
                    _createTextVNode(_toDisplayString(it) + " ", 1),
                    _hoisted_4
                  ]))
                }), 128))
              ]),
              _createElementVNode("td", null, _toDisplayString(item.jsonVariables), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["itemsPerPage", "items", "filter", "totalItemsCount", "onSearch"])
  ]))
}